/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Free_6Inputs */



/**
* | output |
* | --- |
* | "AI Assistant" |
*
* @param {Signup_Feature_Free_6Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_free_6 = /** @type {((inputs?: Signup_Feature_Free_6Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Free_6Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("AI Assistant")
	if (locale === "de") return /** @type {LocalizedString} */ ("AI Assistant")
	if (locale === "it") return /** @type {LocalizedString} */ ("AI Assistant")
	if (locale === "ru") return /** @type {LocalizedString} */ ("AI Assistant")
	if (locale === "es") return /** @type {LocalizedString} */ ("AI Assistant")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AI Assistant")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AI Assistant")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AI Assistant")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("AI Assistant")
	return /** @type {LocalizedString} */ ("AI Assistant")
});